 <template>
  <input-widget :model="model"
                :attribute="attribute"
                type="select2"
                :disabled="disabled"
                display-field=${item.label}
                :hint="hint"
                @select2Select="onSelect"
                :label="label"
                value-field="value"
                :options="{ placeholder: $t('Select template') }"
                :items="fileNameTemplates" />
</template>

<script>
import InputWidget from "./../components/input-widget/InputWidget";
import { createNamespacedHelpers } from "vuex";

const { mapState } = createNamespacedHelpers('global');

export default {
  name: "LotExportImagesNameTemplatesWidget",
  components: { InputWidget },
  props: {
    model: {
      type: Object,
      required: false
    },
    attribute: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => {
        return {};
      }
    },
    label: {
      type: [String, Boolean],
      default: null
    },
    hint: {
      type: [Boolean, String],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      fileNameTemplates: state => {
        return Object.keys(state.auctionImageExportNamingFormat).map(key => {
          return {
            key,
            ...state.auctionImageExportNamingFormat[key],
          };
        });
      }
    }),
  },
  methods: {
    onSelect(data) {
      this.$emit('select', data);
    }
  }
};
</script>

<style scoped>

</style>
